module.exports = __webpack_public_path__ + "static/media/historyOrderBg.f84d6248.png";